import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/marketing/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/apps/marketing/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/app/apps/marketing/components/fragments/cookie-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/apps/marketing/components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/packages/ui/src/components/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@22.15.30_react-dom_9ac67e52a22231b328284a105085c37e/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
